import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "branch-dialog" };
const _hoisted_2 = { class: "row justify-end" };
const _hoisted_3 = { class: "q-pa-md" };
const _hoisted_4 = { class: "row items-center q-gutter-x-lg" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { class: "branch-list" };
const _hoisted_7 = { class: "column items-center justify-center" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "q-pa-sm" };
const _hoisted_10 = {
    key: 0,
    class: "empty-message"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_spinner = _resolveComponent("q-spinner");
    const _component_q_inner_loading = _resolveComponent("q-inner-loading");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_btn, {
                label: "X",
                flat: "",
                onClick: _ctx.closeDialog
            }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", {
            class: "branch-header",
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.back()))
        }, [
            _createVNode(_component_q_icon, {
                name: "navigate_before",
                size: "sm"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.bank.name), 1)
        ]),
        _createVNode(_component_q_separator),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_q_input, {
                    modelValue: _ctx.searchBranch,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.searchBranch) = $event)),
                    class: "search-input",
                    placeholder: "支店名",
                    dense: "",
                    disable: _ctx.isSearch
                }, null, 8, ["modelValue", "disable"]),
                _cache[2] || (_cache[2] = _createElementVNode("span", null, "支店", -1)),
                _createVNode(_component_q_btn, {
                    label: "検索",
                    color: "green",
                    disable: _ctx.isSearch,
                    onClick: _ctx.onSearch
                }, null, 8, ["disable", "onClick"])
            ])
        ]),
        (_ctx.bank.code === '9900')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("div", { class: "text-red q-ml-md" }, " ※支店名は、漢数字で入力してください。 ", -1),
                    _createElementVNode("div", { class: "example-text text-red q-ml-md" }, " （例）二〇八、〇〇八 ", -1)
                ]))]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_q_inner_loading, { showing: _ctx.isSearch }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_q_spinner, {
                            size: "100px",
                            color: "green"
                        }),
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "q-mt-md text-subtitle1" }, " 処理中... ", -1))
                    ])
                ]),
                _: 1
            }, 8, ["showing"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayBranchList, (branch) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: branch.code,
                    class: "branch-row",
                    onClick: ($event) => (_ctx.onRowClick(branch))
                }, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(branch.name), 1),
                    _createVNode(_component_q_separator)
                ], 8, _hoisted_8));
            }), 128)),
            (_ctx.isDataNotFound)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, " データが見つかりませんでした。 "))
                : _createCommentVNode("", true)
        ])
    ]));
}
